import React from 'react';
import { BotIcon, LineChartIcon, DatabaseIcon, UsersIcon, ShieldCheckIcon, ZapIcon, ArrowRightIcon } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
import { useLanguage } from '../contexts/LanguageContext';
export function CapabilitiesSection() {
  const {
    t
  } = useLanguage();
  const capabilities = [{
    icon: BotIcon,
    title: t('capabilities.automated.title'),
    description: t('capabilities.automated.desc')
  }, {
    icon: LineChartIcon,
    title: t('capabilities.analytics.title'),
    description: t('capabilities.analytics.desc')
  }, {
    icon: DatabaseIcon,
    title: t('capabilities.data.title'),
    description: t('capabilities.data.desc')
  }, {
    icon: UsersIcon,
    title: t('capabilities.team.title'),
    description: t('capabilities.team.desc')
  }, {
    icon: ShieldCheckIcon,
    title: t('capabilities.security.title'),
    description: t('capabilities.security.desc')
  }, {
    icon: ZapIcon,
    title: t('capabilities.speed.title'),
    description: t('capabilities.speed.desc')
  }];
  return <section className="py-16 lg:py-24 bg-[#0a0e1a]" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16" data-id="element-26">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-27">
            {t('capabilities.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-28">
            {t('capabilities.subtitle')}
          </p>
        </div>

        {/* Capabilities Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-12" data-id="element-29">
          {capabilities.map((capability, index) => <div key={index} className="bg-gradient-to-br from-[#1a1f36] to-[#111827] rounded-xl border border-white/5 p-6 hover:border-[#ff6b35]/30 transition-colors" data-id="element-30">
              <div className="w-12 h-12 bg-[#ff6b35]/10 rounded-lg flex items-center justify-center mb-4" data-id="element-31">
                <capability.icon className="w-6 h-6 text-[#ff6b35]" data-id="element-32" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2" data-id="element-33">
                {capability.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-34">
                {capability.description}
              </p>
            </div>)}
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-35">
          <button onClick={openCalendlyPopup} className="inline-flex items-center gap-2 bg-[#ff6b35] hover:bg-[#ff5722] text-white px-8 py-4 rounded-lg font-semibold transition-colors" data-id="element-36">
            {t('capabilities.cta')}
            <ArrowRightIcon className="w-5 h-5" data-id="element-37" />
          </button>
        </div>
      </div>
    </section>;
}